import { IModel } from 'core-ts-types';
import * as _4 from 'lodash4';

export interface IPreferencesCommitment {
  id: string;
  value: number;
}

export class PreferencesCommitmentModel implements IModel {
  private _commitment: IPreferencesCommitment = { id: '', value: 0 };

  initialize() {
    this.clear();
  }

  clear(): any {
    this._commitment = { id: '', value: 0 };
    return this;
  }

  write(source: IPreferencesCommitment): PreferencesCommitmentModel {
    this._commitment = source;
    return this;
  }

  read(): IPreferencesCommitment {
    return this._commitment;
  }

  get(commitmentId: number) {
    return this._commitment;
  }

  getTotalCommitment() {
    return this._commitment;
  }

  update(source: IPreferencesCommitment) {
    return this;
  }
}

angular.module('capability-ng-scheduler').service('ngPreferencesCommitmentModel', PreferencesCommitmentModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/models/preferences_commitment_model.ts